import { Action } from 'redux';
import { Video } from '../video/video';
import * as VideoActions from './video.actions';

export interface VideoState {
    currentVideo: Video;
}

const initialState: VideoState = {
    currentVideo: null
};

export const VideoReducer =
    function (state: VideoState = initialState, action: Action): VideoState {
        switch (action.type) {
            case VideoActions.SETCURRENTVIDEO:
                let currentLanguage;
                if (state.currentVideo) {
                    currentLanguage = state.currentVideo.language;
                }
                const video: Video = (<VideoActions.SetCurrentVideoAction>action).video;
                if (currentLanguage && video.languages.length) {
                    video.language = currentLanguage;
                }
                return { currentVideo: video };
            case VideoActions.SETCURRENTLANGUAGE:
                const language = (<VideoActions.SetCurrentLanguageAction>action).language;
                const abc = Object.assign({}, state.currentVideo);
                abc.language = language;
                return { currentVideo: abc };
            case VideoActions.PATCHPLAYLISTS:
                const videos: any = (<VideoActions.PatchPlayListsAction>action).videos;
                const newVideo = Object.assign({}, state.currentVideo);
                newVideo.playlist.guest.alter = videos.GuessList;
                newVideo.playlist.vip.alter = videos.VipList;
                newVideo.playlist.guest.medias.map((m, index) => {
                    if (m.isNew) {
                        newVideo.playlist.guest.alter[index].isNew = m.isNew;
                    }
                });
                newVideo.playlist.vip.medias.map((m, index) => {
                    if (m.isNew) {
                        newVideo.playlist.vip.alter[index].isNew = m.isNew;
                    }
                });
                return { currentVideo: newVideo };

            case VideoActions.ADDSHARECOUNTER:
                const AddShareVideo = Object.assign({}, state.currentVideo);
                AddShareVideo.userData.shared++;
                return { currentVideo: AddShareVideo };
            default:
                return state;
        }
    };

export const getVideoState = (state): VideoState => state.video;

